import { Drawer, Row, Space } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { useBreakpoint } from '../../hooks';
import { Button, Block } from '..';
import { useTranslation } from '../i18n';
import styles from './index.module.less';
import type { EditorProps } from './types';
import type { ReactElement } from 'react';

export function Editor(props: EditorProps): ReactElement {
  const { t } = useTranslation();
  const { md } = useBreakpoint();
  const {
    title = t('编辑'),
    showCancel = true,
    showOk = true,
    onOk,
    onClose,
    children,
    footer,
    width = 600,
    placement = 'right',
    okText = t('保存'),
    cancelText = t('取消'),
    confirmLoading = false
  } = props;

  return (
    <Drawer
      {...props}
      title={<span className={styles.drawerTitle}>{title}</span>}
      width={md === true ? width : 300}
      placement={placement}
      extra={<Icons name='CloseOutlined' onClick={onClose} />}
      closeIcon={null}
      footer={footer ?? (<Row justify='end'>
        <Space size={16}>
          <Block if={showCancel}>
            <Button
              label={cancelText}
              icon='RollbackOutlined'
              onClick={onClose}
            />
          </Block>
          <Block if={showOk}>
            <Button
              type='primary'
              label={okText}
              icon='FileTextOutlined'
              onClick={onOk}
              loading={confirmLoading}
            />
          </Block>
        </Space>
      </Row>)
      }
    >
      {children}
    </Drawer>
  );
}

export type { EditorProps };
